import type { TechniqueEntry } from '../schema';

export const desiredStateElicitation: TechniqueEntry = {
  key: 'desired_state_elicitation',
  version: '0.1',
  name: 'Desired-state elicitation',
  pillar: 'MI',
  serves:
    'Making the life the member actually wants vivid and concrete (how they want to feel and live, not what they want to stop) when only the problem is in the room. The other pole any later discrepancy work needs.',
  method: [
    "Set the substance aside entirely and stay present-tense and concrete, composing each question fresh in the member's vocabulary.",
    "The angles: how they want to feel on an ordinary day, with the substance parked explicitly out of frame; what a stretch of life where it isn't running the show actually looks like: what is different, what they are doing, who is around; and the one feeling they keep reaching for when they picture it.",
    'A vague better or normal is not the destination; ask once more for the concrete version: what better actually feels like, in the body, in their words.',
    'Listen for whether the feeling they reach for is the same one the use gives them: that overlap is the heart of any discrepancy work later, so hold it. Keep their desired state in their own words.',
  ],
  never: [
    'Stay out of the substance entirely while eliciting.',
    'Do not weaponise the desired state into a gap; naming the gap is a different, gated move (develop_discrepancy).',
  ],
  // No prerequisite — richer after a function-of-use descent, but not dependent on it.
  requiresFirst: [],
  doneWhen:
    "A vivid, specific image of the wanted life in the member's own words, including the one feeling they keep reaching for.",
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source: 'shared/sections/practice_objective.md (Movement B)',
};
